"use client";

/**
 * Global Error Boundary — catches unhandled errors across the entire app.
 * This replaces the default Next.js error screen with a user-friendly fallback.
 */

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body className="h-full bg-[#F8F9FB] antialiased">
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="max-w-md text-center space-y-6">
            <div className="flex justify-center">
              <div className="h-16 w-16 rounded-2xl bg-red-50 flex items-center justify-center">
                <span className="text-red-500 text-3xl">!</span>
              </div>
            </div>
            <div className="space-y-2">
              <h1 className="text-xl font-bold text-slate-900">
                Something went wrong
              </h1>
              <p className="text-sm text-slate-500">
                An unexpected error occurred. Please try refreshing the page.
              </p>
              {/* Always show error details for debugging */}
              <div className="mt-4 p-4 bg-slate-100 rounded-lg text-left">
                <p className="text-xs font-mono text-red-600 break-all">
                  {error.message}
                </p>
                {error.digest && (
                  <p className="text-xs text-slate-400 mt-2">
                    Error ID: {error.digest}
                  </p>
                )}
              </div>
            </div>
            <button
              onClick={reset}
              className="inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-semibold text-white
                         bg-[linear-gradient(180deg,#e28530_0%,#d17420_100%)]
                         shadow-sm hover:opacity-90 transition-all"
            >
              Try Again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
